"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.caseStudies = exports.CaseStudiesComponent = void 0;
const app_1 = require("app");
class CaseStudiesComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.case-studies-grid';
        this.buttonSelector = '.link-button.link-button--plus';
        this.buttonContainerSelector = '.case-studies__btn';
        this.hiddenElClass = 'case-study-wrap--hidden';
        this.hiddenBtnContainerClass = 'case-studies__btn--hidden';
    }
    OnInit() {
        const btns = this.el[0].querySelectorAll(this.buttonSelector);
        btns.forEach(btn => {
            btn.addEventListener('click tap', e => {
                e.preventDefault();
                document
                    .querySelectorAll(`.${this.hiddenElClass}`)
                    .forEach(elem => elem.classList.remove(this.hiddenElClass));
                $(btn).closest(this.buttonContainerSelector).addClass(this.hiddenBtnContainerClass);
                return false;
            });
        });
    }
}
exports.CaseStudiesComponent = CaseStudiesComponent;
exports.caseStudies = new CaseStudiesComponent();
